<template>
    <CreatePassword />
</template>

<script>
//Store
import { mapGetters } from "vuex";
//Components
import CreatePassword from "@/app/components/create-password/create-password";

export default {
    name: 'Create-password-view',
    components: { CreatePassword },
    computed: {
        ...mapGetters('authenticateStore', {
                isLoggedIn: 'isLoggedIn'
            }
        )
    },
    watch: {
        isLoggedIn: {
            deep: true,
            immediate: true,
            handler() {
                this.isLoggedIn ? this.$router.push('/perfil') : ''
            }
        }
    }
}
</script>